import React, { useState } from 'react';
import styled from 'styled-components';
import BaseButton from './BaseButton';

import { Colors } from '../../../../scss/common/style';

interface Props {
  size?: 'sm' | 'lg' | undefined;
  onClick?: () => void;
  title?: string;
  isSubmitting?: boolean;
  active?: boolean;
  disabled?: boolean;
  type?: 'button' | 'reset' | 'submit';
}

export default function PrimaryButton({
  onClick,
  title,
  isSubmitting = false,
  active = false,
  disabled = false,
  type,
  size = undefined,
}: Props): JSX.Element {


  return (
    <StyledButton>
      <BaseButton
        type={type}
        title={title}
        onClick={onClick}
        isSubmitting={isSubmitting}
        disabled={disabled}
        active={active}
        className="base-button"
        size={size}
      />
    </StyledButton>
  );
}

const StyledButton = styled.div`
  div {
    margin: 0;
  }
  button {
    background-color: ${Colors.newOrage};
    border-radius: 200px;
    color: #fff;
    &:hover {
      background-color: ${Colors.darkRed};
      border-color: ${Colors.darkRed};
      color: '#fff';
    }
    &:active {
      background-color: ${Colors.darkBrown};
      border-color: ${Colors.darkBrown};
    }
  }
`;
